import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const TenantComparisonRoutes: RouteBundle = {
  domain: 'tenant-comparison',
  routes: [
    {
      urlPattern: 'tools/tenant-comparison',
      handler: EditorRoutes.tenantComparisonPage.bind(EditorRoutes),
      legacy: false,
    },
  ],
};
